import axios from "axios";

import { Sites } from "../../../modules/constants";

import { fetchAvailableRoles } from "../../../modules/profileManagement";
import {
  orderType,
  tablePageSizes,
} from "../../ui-library/CustomTable/constants";
import {
  unlockUser,
  blockUnblockUser,
} from "../../../modules/profileManagement";
import { getClaims, decrypt } from "../../../modules/login";
import {
  resendInvite,
  resetPassword,
} from "../../../modules/profileManagement";
import { UserStatus } from "../../library/AccountStatus/AccountStatus.constants";
import { handleHttpErrors } from "../../../modules/http";

// Constants
const LOADING_NON_PARTICIPANTS = "LOADING_NON_PARTICIPANTS";
const SET_NON_PARTICIPANTS = "SET_NON_PARTICIPANTS";
const SET_SITES = "SET_SITES";
const RESET_STATE = "RESET_STATE";
const LOGOUT = "LOGOUT";

// Acessors
const getAccountUsername = (state) => decrypt(state?.loginReducer.username);
const getNonParticipants = (state) => state?.nonParticipants;
const getTotalItems = (state) => state?.totalItems;
const getSearchedParams = (state) => state?.searchedParams;
const getLoading = (state) => state?.loading;

const getSites = (state) => state.sites;

const canBlockUser = (state) => getClaims(state, "nonParticipant.canBlock");
const canUnlockUser = (state) => getClaims(state, "nonParticipant.canUnlock");
const canEditUser = (state) => getClaims(state, "nonParticipant.canEdit");
const canAddNonParticipant = (state) => getClaims(state, "site.users.canEdit");
const canAddSite = (state) => getClaims(state, "site.canEdit");
const canResendInviteNonParticipant = (state) =>
  getClaims(state, "nonParticipant.canResendInvite");
const canResetPasswordNonParticipant = (state) =>
  getClaims(state, "nonParticipant.canResetPassword");

// Default state
const initialState = {
  nonParticipants: [],
  totalItems: null,
  loading: false,
  searchedParams: {
    page: 0,
    limit: tablePageSizes[0],
    siteId: Sites.ALL.id,
    search: "",
    orderBy: "created",
    order: orderType.DESC,
    filter: UserStatus.ALL.id,
  },
  sites: [],
};

export const nonParticipantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING_NON_PARTICIPANTS:
      return {
        ...state,
        loading: true,
      };
    case SET_NON_PARTICIPANTS:
      const { data, searchedParams } = action;
      return {
        ...state,
        nonParticipants: data.data,
        totalItems: data.records,
        searchedParams: searchedParams,
        loading: false,
      };
    case SET_SITES:
      const { sites } = action;

      return {
        ...state,
        sites: sites,
      };
    case RESET_STATE:
      return initialState;
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

const resetState = () => (dispatch) => {
  dispatch({ type: RESET_STATE });
};

const fetchNonParticipants = (searchedParams, studyId) => (dispatch) => {
  const params = {
    ...searchedParams,
    studyId: studyId,
  };

  dispatch({
    type: LOADING_NON_PARTICIPANTS,
  });

  return axios
    .get(`/api/nonparticipants`, { params })
    .then(({ data }) => {
      dispatch({
        type: SET_NON_PARTICIPANTS,
        data,
        searchedParams,
      });
    })
    .catch((error) => {
      // if statement to avoid to show an error when the request is canceled
      if (error?.message === "cancel") {
        return;
      }

      const defaultMessage = error.response?.data
        ? error.response.data
        : "There was an error while trying to fetch non-participants!";

      return handleHttpErrors(error.request?.status, {
        default: defaultMessage,
      });
    });
};

export const fetchSites = (studyId) => (dispatch) => {
  const params = {
    studyId: studyId,
  };

  return axios
    .get(`/api/study/sites`, { params })
    .then(({ data }) => {
      const sites = data?.sort((a, b) => {
        return a.name.localeCompare(b.name);
      });
      dispatch({ type: SET_SITES, sites: sites });
    })
    .catch(() => {});
};

export const mapStateToProps = (state) => {
  return {
    nonParticipants: getNonParticipants(state),
    totalItems: getTotalItems(state),
    searchedParams: getSearchedParams(state),
    loading: getLoading(state),
    sites: getSites(state),
    canBlockUser: canBlockUser(state),
    canUnlockUser: canUnlockUser(state),
    canEditUser: canEditUser(state),
    canAddNonParticipant: canAddNonParticipant(state),
    canAddSite: canAddSite(state),
    accountUsername: getAccountUsername(state),
    canResendInviteNonParticipant: canResendInviteNonParticipant(state),
    canResetPasswordNonParticipant: canResetPasswordNonParticipant(state),
  };
};

export const mapDispatchToProps = {
  fetchNonParticipants,
  unlockUser,
  blockUnblockUser,
  fetchSites,
  fetchAvailableRoles,
  resendInvite,
  resetPassword,
  resetState,
};
